import Repository from '../../repositories/RepositoryFactory';
const ccmAllergyRepository = Repository.get('ccmAllergy');

export default {
	namespaced: true,
	state: {
		ccmAllergyByPatientId: [],
		ccmAllergyByCCMRecordId: [],
		ccmAllergy: null,
	},
	mutations: {
		STORE_CCM_ALLERGY_BY_PATIENT_ID (state, payload) {
			state.ccmAllergyByPatientId = payload;
		},
		STORE_CCM_ALLERGY_BY_CCM_RECORD_ID (state, payload) {
			state.ccmAllergyByCCMRecordId = payload;
		},
		STORE_CCM_ALLERGY (state, payload) {
			state.ccmAllergy = payload;
		},
		UPDATE_CCM_ALLERGY (state, payload) {
			state.ccmAllergy = {
				...state.ccmAllergy,
				...payload,
			};
		},
		UPDATE_CCM_ALLERGY_IN_RECORD_LIST (state, id, payload) {
			const index = state.ccmAllergyByCCMRecordId.findIndex((record) => record.id === id);
			if (index !== -1) {
				state.ccmAllergyByCCMRecordId.splice(index, 1, {
					...state.ccmAllergyByCCMRecordId[index],
					...payload,
				});
			}
		},
		REMOVE_CCM_ALLERGY (state, id) {
			state.ccmAllergyByCCMRecordId = state.ccmAllergyByCCMRecordId.filter((record) => record.id !== id);
		},
	},
	actions: {
		async getCCMAllergyByPatientId ({ commit }, patientId) {
			const response = await ccmAllergyRepository.getCCMAllergyByPatientId(patientId);
			commit('STORE_CCM_ALLERGY_BY_PATIENT_ID', response.data);
		},

		async getCCMAllergyByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmAllergyRepository.getCCMAllergyByCCMRecordId(ccmRecordId);
			commit('STORE_CCM_ALLERGY_BY_CCM_RECORD_ID', response.data);
		},

		async getCCMAllergy ({ commit }, id) {
			const response = await ccmAllergyRepository.getCCMAllergy(id);
			commit('STORE_CCM_ALLERGY', response.data);
		},

		async addCCMAllergy ({ commit }, body) {
			return await ccmAllergyRepository.addCCMAllergy(body);
		},

		async updateCCMAllergy ({ commit }, request) {
			commit('UPDATE_CCM_ALLERGY', request.body);
			commit('UPDATE_CCM_ALLERGY_IN_RECORD_LIST', request.id, request.body);
			return await ccmAllergyRepository.updateCCMAllergy(request.id, request.body);
		},

		async deleteCCMAllergy ({ commit }, id) {
			commit('REMOVE_CCM_ALLERGY', id);
			return await ccmAllergyRepository.deleteCCMAllergy(id);
		},
	},
};
